// extracted by mini-css-extract-plugin
module.exports = {"scroll":"D35ux","card_wrapper":"iN5CR","slider":"gsLUB","mobile_intersection":"ZgoV8","web_intersection":"D0Yvn"};